import styled from 'styled-components';

// 개발(헤츠너 .kr / dev.*)과 운영은 화면이 똑같이 생겼다. 그래서 개발에서
// 만진 것을 운영에서 한 줄 알고 넘어가기 쉽다.
//
// 화면 맨 위에 두면 헤더를 가려 본래 내용이 밀린다. 아래에 고정해 어느
// 화면을 보든 눈에는 들어오되 방해하지 않게 한다.
// 운영에서는 아무것도 그리지 않는다.
//
// 앤츠네스트 포털의 같은 컴포넌트와 판단 기준을 맞춘다. 한쪽만 고치면
// 어느 화면에서는 개발인지 모른 채 쓰게 된다.
const FAMILIES = ['antsnest.kr', 'antsnest.co.kr'];

function familyOf(hostname) {
  const host = String(hostname || '').toLowerCase();
  return FAMILIES.find((d) => host === d || host.endsWith('.' + d)) || null;
}

export function environmentLabel(location = window.location) {
  const host = String(location.hostname || '').toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') return '로컬';
  if (host.startsWith('dev.')) return '개발';
  return familyOf(host) === 'antsnest.kr' ? '개발' : null;
}

const Bar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2147483000;
  width: 100%;
  padding: 4px 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: #422006;
  pointer-events: none;
  background: repeating-linear-gradient(
    45deg,
    #fbbf24,
    #fbbf24 10px,
    #f59e0b 10px,
    #f59e0b 20px
  );
  border-top: 1px solid #b45309;
`;

const Host = styled.span`
  font-weight: 500;
  opacity: 0.85;
  font-size: 10.5px;
`;

export default function EnvironmentBadge() {
  const label = environmentLabel();
  if (!label) return null;
  return (
    <Bar role="status" aria-label={`${label} 환경`}>
      {label} 환경 · 운영이 아닙니다
      <Host>{window.location.hostname}</Host>
    </Bar>
  );
}
